/* eslint-disable import/prefer-default-export */
import BigNumber from 'bignumber.js';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { currencies, exchange as exchangeConfig } from '../constants';
import { formatNumber } from '../formatHelpers';
import { RATES_QUERY_KEY } from '../sharedQueries';

export const useRateDetails = (source, destination, withoutRounding = false) => {
  const { data: rates } = useQuery(RATES_QUERY_KEY);

  return useMemo(() => {
    if (rates) {
      if (!source || !destination) {
        return { rate: '0.00', change: '0.00' };
      }
      const _source = source?.toUpperCase();
      const _destination = destination?.toUpperCase();
      let _rate = 0;
      let _changes = 0;
      if (_source === _destination) {
        _rate = 1;
        _changes = 0;
      } else if (rates[`${_source}${_destination}`]) {
        _rate = new BigNumber(rates[`${_source}${_destination}`].ask);
        _changes = new BigNumber(rates[`${_source}${_destination}`].pctChange1d);
      } else if (rates[`${_destination}${_source}`]) {
        _rate = new BigNumber(1).dividedBy(rates[`${_destination}${_source}`].ask);
        _changes = 0;
      }
      return {
        rate: withoutRounding
          ? formatNumber(_rate, exchangeConfig.CRYPTO_VALUE)
          : formatNumber(_rate, currencies[_destination].decimal),
        change: formatNumber(_changes, exchangeConfig.FIAT_VALUE),
      };
    }
    return { rate: '0.00', change: '0.00' };
  }, [destination, source, rates, withoutRounding]);
};

export const useRate = (source, destination, withoutRounding = false) => {
  const { rate } = useRateDetails(source, destination, withoutRounding);
  return rate;
};
